/**
 * Waarop ligt het micro-slot als je in het attributenpaneel werkt?
 *
 * Zie `docs/architecture/gelijktijdigheid.md`. Twee korrels, en de keuze volgt
 * de plek waar de waarden werkelijk staan:
 *
 * - **Op het voorkomen** (instance-opslag): het slot hoort op de
 *   viewState-sleutel. Twee mensen op twee verschillende voorkomens van
 *   hetzelfde object horen elkaar niet in de weg te zitten — een voorkomen is
 *   een uniek gegeven.
 * - **Op het object**: dan is het object de korrel, en sluiten twee mensen
 *   elkaar terecht uit.
 *
 * Losstaand zodat de keuze te toetsen is zonder het paneel op te tuigen, en
 * zodat er één beslissing is in plaats van twee die uit elkaar kunnen lopen.
 */
export function lockTargetFor(input: {
  /** Staan de attribuutwaarden op het voorkomen in plaats van op het object? */
  storeOnInstance: boolean;
  /** De viewState-sleutel van het geselecteerde voorkomen, indien bekend. */
  instanceId: string | null;
  conceptId: string | null;
  relationId: string | null;
}): string | null {
  if (input.storeOnInstance && input.instanceId) return input.instanceId;
  return input.conceptId ?? input.relationId ?? null;
}
